export default {
  'menu.zy-hr.workbench': '工作台',
  'menu.zy-hr.dashboard': '人事看板',
  'menu.zy-hr.employeeCenter': '員工中心',
  'menu.zy-hr.employeeWorkbench': 'HR工作臺',
  'menu.zy-hr.employee': '員工花名冊',
  'menu.zy-hr.employee.recycleBin': '員工回收站',
  'menu.zy-hr.employee.detail': '員工詳情',
  'menu.zy-hr.me': '我的工作臺',
  'menu.zy-hr.employeePortalSettings': '員工端設定',
  'menu.zy-hr.laborRelations': '勞動關係',
  'menu.zy-hr.onboarding': '待入職',
  'menu.zy-hr.regularization': '轉正',
  'menu.zy-hr.employeeChange': '員工異動',
  'menu.zy-hr.profileChange': '自助資料變更',
  'menu.zy-hr.employeeLifecycleAudits': '生命週期審計',
  'menu.zy-hr.certificateRequests': '證明申請',
  'menu.zy-hr.employeeRelationsAnalysis': '員工關係分析',
  'menu.zy-hr.employeeCenterSettings': '員工中心設定',
  'menu.zy-hr.resignation': '離職',
  'menu.zy-hr.attendanceCenter': '考勤中心',
  'menu.zy-hr.payrollCenter': '薪酬中心',
  'menu.zy-hr.payroll.workbench': '薪酬工作臺',
  'menu.zy-hr.payroll.plans': '薪資方案',
  'menu.zy-hr.payroll.items': '薪資項目',
  'menu.zy-hr.payroll.profiles': '員工薪資檔案',
  'menu.zy-hr.payroll.deductions': '扣繳結果',
  'menu.zy-hr.payroll.adjustments': '調薪管理',
  'menu.zy-hr.payroll.runs': '算薪批次',
  'menu.zy-hr.payroll.slips': '薪資台帳',
  'menu.zy-hr.socialInsuranceCenter': '社保中心',
  'menu.zy-hr.socialInsurance.workbench': '社保工作臺',
  'menu.zy-hr.socialInsurance.policies': '參保方案',
  'menu.zy-hr.socialInsurance.accounts': '參保檔案',
  'menu.zy-hr.socialInsurance.changes': '增減員管理',
  'menu.zy-hr.socialInsurance.bills': '繳費台帳',
  'menu.zy-hr.performanceCenter': '績效中心',
  'menu.zy-hr.performance.cycles': '績效週期',
  'menu.zy-hr.performance.goals': '績效目標',
  'menu.zy-hr.performance.reviews': '績效評估',
  'menu.zy-hr.performance.interviews': '績效面談',
  'menu.zy-hr.performance.results': '績效結果',
  'menu.zy-hr.performance.gradeRules': '等級規則',
  'menu.zy-hr.trainingLearningCenter': '培訓學習中心',
  'menu.zy-hr.careerPlanning': '職業規劃',
  'menu.zy-hr.talentInventory': '人才盤點',
  'menu.zy-hr.foundationConfig': '基礎配置',
  'menu.zy-hr.processReminder': '流程與提醒',
  'menu.zy-hr.approval': '待我審批',
  'menu.zy-hr.approvalRecords': '審批記錄',
  'menu.zy-hr.approvalAbnormalRecords': '異常審批記錄',
  'menu.zy-hr.approvalDelegates': '審批代理',
  'menu.zy-hr.approvalHandovers': '審批交接',
  'menu.zy-hr.approvalInstances': '審批實例',
  'menu.zy-hr.approvalTemplates': '審批模板',
  'menu.zy-hr.organization.unit': '組織管理',
  'menu.zy-hr.organization.position': '崗位管理',
  'menu.zy-hr.organization.jobLevel': '職級管理',
  'menu.zy-hr.organization.workLocation': '工作地點',
  'menu.zy-hr.organization.employeeTag': '員工標籤',
  'menu.zy-hr.organization.roles': '角色權限',
  'menu.zy-hr.organization.permissions': '權限碼維護',
  'menu.zy-hr.attendance.workbench': '考勤工作臺',
  'menu.zy-hr.attendance.shifts': '班次庫',
  'menu.zy-hr.attendance.groups': '考勤組',
  'menu.zy-hr.attendance.schedules': '排班日曆',
  'menu.zy-hr.attendance.holidayPlans': '假期方案',
  'menu.zy-hr.attendance.record': '考勤記錄',
  'menu.zy-hr.attendance.daily': '日考勤結果',
  'menu.zy-hr.attendance.monthly': '月考勤表',
  'menu.zy-hr.attendance.leaveBalances': '假期餘額',
  'menu.zy-hr.attendance.leaveGrantPolicies': '假期發放規則',
  'menu.zy-hr.attendance.leave': '請假申請',
  'menu.zy-hr.attendance.overtime': '加班申請',
  'menu.zy-hr.attendance.punch': '補卡申請',
  'menu.zy-hr.attendance.setting': '考勤設定',
  'menu.zy-hr.reminder': '人事提醒',
  'menu.zy-hr.systemUpdates': '系統更新',
  'menu.login': '登入',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.logout': '退出登入',
};
